import QUICK_BEAUTY from 'bl/salon/quickBeauty';
import QUICK_HAIR_AND_BEAUTY from 'bl/salon/quickHairAndBeauty';
import QST from 'constants/quickSetupType.const';

const generateQuickSetupConfig = ({ type }) => {
  if (type === QST.hair) return QUICK_HAIR_AND_BEAUTY;
  if (type === QST.beauty) return QUICK_BEAUTY;

  return QUICK_HAIR_AND_BEAUTY;
};

export default generateQuickSetupConfig;
